import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://local-yt-trends.ru';
const API_KEY = process.env.REACT_APP_API_KEY || 'test-key-123';

class GameService {
    async createSession(videoId, countries, timeLimit = 300) {
        const playerId = this.getOrCreatePlayerId();
        
        try {
            const response = await axios.post(
                `${API_URL}/api/game/session/create`,
                {
                    playerId,
                    videoId,
                    countries,
                    timeLimit
                },
                {
                    headers: {
                        'X-API-KEY': API_KEY,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error creating game session:', error);
            throw error;
        }
    }

    async joinSession(sessionId) {
        const playerId = this.getOrCreatePlayerId();
        
        try {
            const response = await axios.post(
                `${API_URL}/api/game/session/${sessionId}/join`,
                { playerId },
                {
                    headers: {
                        'X-API-KEY': API_KEY,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error joining game session:', error);
            throw error;
        }
    }

    async getSession(sessionId) {
        try {
            const response = await axios.get(
                `${API_URL}/api/game/session/${sessionId}`,
                {
                    headers: {
                        'X-API-KEY': API_KEY
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error getting game session:', error);
            throw error;
        }
    }

    async updateProgress(sessionId, playerId, guessedCountries, errors = 0) {
        try {
            const response = await axios.post(
                `${API_URL}/api/game/session/${sessionId}/progress`,
                {
                    playerId,
                    guessedCountries: Array.isArray(guessedCountries) ? guessedCountries : Array.from(guessedCountries),
                    errors
                },
                {
                    headers: {
                        'X-API-KEY': API_KEY,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error updating progress:', error);
            throw error;
        }
    }

    getOrCreatePlayerId() {
        let playerId = localStorage.getItem('gamePlayerId');
        if (!playerId) {
            playerId = 'player_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
            localStorage.setItem('gamePlayerId', playerId);
        }
        return playerId;
    }

    getPlayerId() {
        return this.getOrCreatePlayerId();
    }

    async getMercureToken() {
        try {
            const response = await axios.get(
                `${API_URL}/api/game/mercure-token`,
                {
                    headers: {
                        'X-API-KEY': API_KEY
                    }
                }
            );
            return response.data.token;
        } catch (error) {
            console.error('Error getting Mercure token:', error);
            throw error;
        }
    }
}

const gameService = new GameService();
export default gameService;

